var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "order"
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-2"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse1",
      modifiers: {
        "collapse1": true
      }
    }],
    staticClass: " fa fa-filter filter",
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-actions"
  })]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "visible": "",
      "id": "collapse1"
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "method": "post"
    }
  }, [(_vm.showSelectClient || _vm.showSelectWarehouse) ? _c('div', {
    staticClass: "form-group row"
  }) : _vm._e()])])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('b-tabs', [_c('b-tab', {
    staticClass: "show",
    attrs: {
      "title": _vm.$t('consolidation.batchPendingTab'),
      "active": ""
    },
    on: {
      "click": _vm.resetBatchPending
    }
  }, [_c('div', {
    staticClass: "card-headerfrmOrd"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.orderID')) + ":")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-bookmark'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('common.orderIDPlaceholder'),
      "name": "orderid",
      "id": "orderid"
    },
    model: {
      value: (_vm.orderid),
      callback: function($$v) {
        _vm.orderid = $$v
      },
      expression: "orderid"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.zoneName')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.zoneBatchPending),
      expression: "zoneBatchPending"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "zoneBatchPending"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.zoneBatchPending = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getOrderListForBatchCreation]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('common.zonePlaceHolder')))]), _vm._v(" "), _vm._l((_vm.zonelistData), function(zone) {
    return _c('option', {
      domProps: {
        "value": zone.zoneid
      }
    }, [_vm._v(_vm._s(zone.zonename))])
  })], 2)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.salesChannel')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchchannel),
      expression: "searchchannel"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "searchchannel"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.searchchannel = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('common.salesChannelPlaceholder')))]), _vm._v(" "), _vm._l((_vm.channellist), function(channel) {
    return _c('option', {
      domProps: {
        "value": channel.saleschannel
      }
    }, [_vm._v(_vm._s(channel.saleschannel))])
  })], 2)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('common.createdFromDate')) + " :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder')
    },
    model: {
      value: (_vm.fromDateBatchPending),
      callback: function($$v) {
        _vm.fromDateBatchPending = $$v
      },
      expression: "fromDateBatchPending"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('common.createdToDate')) + " :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder')
    },
    model: {
      value: (_vm.toDateBatchPending),
      callback: function($$v) {
        _vm.toDateBatchPending = $$v
      },
      expression: "toDateBatchPending"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "30px",
      "margin-left": "300px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.getOrderListForBatchCreationSearch
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" " + _vm._s(_vm.$t('common.searchBtn')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetBatchPending
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" " + _vm._s(_vm.$t('common.resetBtn')))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "height": "25px"
    }
  }, [_c('div', {
    staticClass: "col-md-4 cardlistheader"
  }, [_c('h4', {
    staticClass: "header",
    staticStyle: {
      "color": "black"
    }
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('consolidation.batchPendingReportTitle')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 cardlistheader"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('b', {
    staticStyle: {
      "font-family": "cursive,fantasy",
      "color": "green"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.$t('common.table.count')) + " - " + _vm._s(this.listpendingForBatchData.totalquantity))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [(_vm.listpendingForBatchData.totalquantity > 0 && _vm.orderItemids != '' && _vm.zoneBatchPending != '') ? _c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "margin-top": "-10px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.assignOrderToBatch
    }
  }, [_vm._v(_vm._s(_vm.$t('consolidation.createBatch')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-0.5 cardlistheader"
  }, [_c('loader', {
    staticStyle: {
      "margin-right": "-400px"
    },
    attrs: {
      "isLoading": _vm.isLoadingforxls
    }
  })], 1), _vm._v(" "), (_vm.download && _vm.listpendingForBatchData.totalquantity) ? _c('div', {
    staticClass: "col-md-0.5"
  }, [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    staticStyle: {
      "margin-right": "-150px"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.Choosetype(1)
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.downloadBtn')))])]) : _vm._e(), _vm._v(" "), (_vm.show && _vm.listpendingForBatchData.totalquantity) ? _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    staticStyle: {
      "margin-right": "-30px"
    },
    attrs: {
      "disabled": _vm.isLoading,
      "title": _vm.$t('common.downloadCsv')
    },
    on: {
      "click": function($event) {
        _vm.getOrderListForBatchCreationCSV(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])]) : _vm._e(), _vm._v(" "), (_vm.limitExeed && _vm.show && _vm.listpendingForBatchData.totalquantity) ? _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    staticStyle: {
      "margin-right": "5px"
    },
    attrs: {
      "disabled": _vm.isLoading,
      "title": _vm.$t('common.downloadXls')
    },
    on: {
      "click": function($event) {
        _vm.getOrderListForBatchCreationForXls(3)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o"
  })])]) : _vm._e(), _vm._v(" "), (!_vm.limitExeed && _vm.show && _vm.listpendingForBatchData.totalquantity) ? _c('div', {
    staticClass: "col-md-1"
  }, [_c('download-excel', {
    staticClass: "btn btn-info downloadbutton",
    staticStyle: {
      "margin-right": "5px"
    },
    attrs: {
      "before-generate": _vm.startDownload,
      "before-finish": _vm.finishDownload,
      "title": _vm.$t('common.downloadXls'),
      "data": _vm.listReportDataforxls,
      "header": _vm.dataFilter2,
      "fields": _vm.csvFieldsForXls,
      "worksheet": "MyWorksheet",
      "name": _vm.reportname1
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable",
    attrs: {
      "id": "my-table"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [(_vm.zoneBatchPending != '') ? _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "bind-title": "Select All"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectAllBatchPending),
      expression: "selectAllBatchPending"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.selectAllBatchPending) ? _vm._i(_vm.selectAllBatchPending, null) > -1 : (_vm.selectAllBatchPending)
    },
    on: {
      "click": _vm.selectAllCheckboxBathPending,
      "__c": function($event) {
        var $$a = _vm.selectAllBatchPending,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.selectAllBatchPending = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.selectAllBatchPending = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.selectAllBatchPending = $$c
        }
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.zoneName')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.orderID')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.salesChannel')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.productId')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.eanCode')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.rackID')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.qty')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('consolidation.taskCreatedDate')))])])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.listpendingForBatchData.result), function(data) {
    return _c('tr', {
      staticClass: "text-center cardreporttabletr"
    }, [(_vm.zoneBatchPending != '') ? _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.orderItemids),
        expression: "orderItemids"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": data.id,
        "checked": Array.isArray(_vm.orderItemids) ? _vm._i(_vm.orderItemids, data.id) > -1 : (_vm.orderItemids)
      },
      on: {
        "change": function($event) {
          _vm.resetAllBatchPending(data)
        },
        "__c": function($event) {
          var $$a = _vm.orderItemids,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = data.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.orderItemids = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.orderItemids = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.orderItemids = $$c
          }
        }
      }
    })]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getZoneName(data.zoneid)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.orderid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.saleschannel))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.productid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.eancode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.rackid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.qty))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("momentDateTime")(data.createddate)))])])
  }), _vm._v(" "), (_vm.listpendingForBatchData.totalquantity <= 0 || (_vm.listpendingForBatchData.result && _vm.listpendingForBatchData.result.length <= 0)) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "12",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.table.noRecordFoundMsg')))])]) : _vm._e()], 2)])]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('b-tab', {
    staticClass: "show",
    attrs: {
      "title": _vm.$t('consolidation.pendingAllocationTab')
    },
    on: {
      "click": _vm.resetAllocatePending
    }
  }, [_c('div', {
    staticClass: "card-headerfrmOrd"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.zoneName')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.zoneBatchPending),
      expression: "zoneBatchPending"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "zoneBatchPending"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.zoneBatchPending = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getPendinAllocationBatchSearch]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('common.zonePlaceHolder')))]), _vm._v(" "), _vm._l((_vm.zonelistData), function(zone) {
    return _c('option', {
      domProps: {
        "value": zone.zoneid
      }
    }, [_vm._v(_vm._s(zone.zonename))])
  })], 2)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('common.createdFromDate')) + " :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder')
    },
    model: {
      value: (_vm.fromDateAllocatePending),
      callback: function($$v) {
        _vm.fromDateAllocatePending = $$v
      },
      expression: "fromDateAllocatePending"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('common.createdToDate')) + " :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder')
    },
    model: {
      value: (_vm.toDateAllocatePending),
      callback: function($$v) {
        _vm.toDateAllocatePending = $$v
      },
      expression: "toDateAllocatePending"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "30px",
      "margin-left": "20px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.getPendinAllocationBatchSearch
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" " + _vm._s(_vm.$t('common.searchBtn')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetAllocatePending
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" " + _vm._s(_vm.$t('common.resetBtn')))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "height": "25px"
    }
  }, [_c('div', {
    staticClass: "col-md-4 cardlistheader"
  }, [_c('h4', {
    staticClass: "header",
    staticStyle: {
      "color": "black"
    }
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('consolidation.batchPendingReportTitle')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 cardlistheader"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('b', {
    staticStyle: {
      "font-family": "cursive,fantasy",
      "color": "green"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.$t('common.table.count')) + " - " + _vm._s(this.listpendingForAllocationData.totalquantity))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [(_vm.listpendingForAllocationData.totalquantity > 0 && _vm.pendingbatchids != '') ? _c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "margin-top": "-10px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.pickerAssignmentShow = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('orders.assignToPicker')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-0.5 cardlistheader"
  }, [_c('loader', {
    staticStyle: {
      "margin-right": "-400px"
    },
    attrs: {
      "isLoading": _vm.isLoadingforxls
    }
  })], 1), _vm._v(" "), (_vm.download && _vm.listpendingForAllocationData.totalquantity) ? _c('div', {
    staticClass: "col-md-0.5"
  }, [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    staticStyle: {
      "margin-right": "-150px"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.Choosetype2(1)
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.downloadBtn')))])]) : _vm._e(), _vm._v(" "), (_vm.show && _vm.listpendingForAllocationData.totalquantity) ? _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    staticStyle: {
      "margin-right": "-30px"
    },
    attrs: {
      "disabled": _vm.isLoading,
      "title": _vm.$t('common.downloadCsv')
    },
    on: {
      "click": function($event) {
        _vm.getPendinAllocationBatchCSV(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])]) : _vm._e(), _vm._v(" "), (_vm.limitExeed && _vm.show && _vm.listpendingForAllocationData.totalquantity) ? _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    staticStyle: {
      "margin-right": "5px"
    },
    attrs: {
      "disabled": _vm.isLoading,
      "title": _vm.$t('common.downloadXls')
    },
    on: {
      "click": function($event) {
        _vm.getPendinAllocationBatchForXls(3)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o"
  })])]) : _vm._e(), _vm._v(" "), (!_vm.limitExeed && _vm.show && _vm.listpendingForAllocationData.totalquantity) ? _c('div', {
    staticClass: "col-md-1"
  }, [_c('download-excel', {
    staticClass: "btn btn-info downloadbutton",
    staticStyle: {
      "margin-right": "5px"
    },
    attrs: {
      "before-generate": _vm.startDownload,
      "before-finish": _vm.finishDownload,
      "title": _vm.$t('common.downloadXls'),
      "data": _vm.listReportDataforxls2,
      "header": _vm.dataFilter2,
      "fields": _vm.csvFieldsForXls2,
      "worksheet": "MyWorksheet",
      "name": _vm.reportname2
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable",
    attrs: {
      "id": "my-table"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "bind-title": "Select All"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectAllAllocationPending),
      expression: "selectAllAllocationPending"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.selectAllAllocationPending) ? _vm._i(_vm.selectAllAllocationPending, null) > -1 : (_vm.selectAllAllocationPending)
    },
    on: {
      "click": _vm.selectAllCheckboxAllocationPending,
      "__c": function($event) {
        var $$a = _vm.selectAllAllocationPending,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.selectAllAllocationPending = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.selectAllAllocationPending = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.selectAllAllocationPending = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.zoneName')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.batchID')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('consolidation.picksTasks')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('consolidation.createdDatetime')))])])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.listpendingForAllocationData.result), function(data) {
    return _c('tr', {
      staticClass: "text-center cardreporttabletr"
    }, [_c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.pendingbatchids),
        expression: "pendingbatchids"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": data.batchid,
        "checked": Array.isArray(_vm.pendingbatchids) ? _vm._i(_vm.pendingbatchids, data.batchid) > -1 : (_vm.pendingbatchids)
      },
      on: {
        "change": function($event) {
          _vm.resetAllAllocationPending(data)
        },
        "__c": function($event) {
          var $$a = _vm.pendingbatchids,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = data.batchid,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.pendingbatchids = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.pendingbatchids = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.pendingbatchids = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getZoneName(data.zoneid)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.batchid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.batchcount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("momentDateTime")(data.createddatetime)))])])
  }), _vm._v(" "), (_vm.listpendingForAllocationData.totalquantity <= 0 || (_vm.listpendingForAllocationData.result && _vm.listpendingForAllocationData.result.length <= 0)) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "12",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.table.noRecordFoundMsg')))])]) : _vm._e()], 2)])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.totalPage > 0) ? _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPage,
      "total": _vm.totalRows,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPage
    },
    on: {
      "pagechanged": _vm.onPageChange
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('b-tab', {
    staticClass: "show",
    attrs: {
      "title": _vm.$t('consolidation.allocateInPickingTab')
    },
    on: {
      "click": _vm.resetAllAllocatedForm
    }
  }, [_c('div', {
    staticClass: "card-headerfrmOrd"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.zoneName')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.zoneBatchPending),
      expression: "zoneBatchPending"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "zoneBatchPending"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.zoneBatchPending = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getAllocatedPendingBatchesSearch]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('common.zonePlaceHolder')))]), _vm._v(" "), _vm._l((_vm.zonelistData), function(zone) {
    return _c('option', {
      domProps: {
        "value": zone.zoneid
      }
    }, [_vm._v(_vm._s(zone.zonename))])
  })], 2)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('consolidation.picker')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pickeridAllocated),
      expression: "pickeridAllocated"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "pickeridAllocated"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.pickeridAllocated = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getAllocatedPendingBatchesSearch]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('common.selectPicker')))]), _vm._v(" "), _vm._l((_vm.pickerListData), function(user_obj) {
    return _c('option', {
      domProps: {
        "value": user_obj.userid
      }
    }, [_vm._v(_vm._s(user_obj.email))])
  })], 2)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('common.createdFromDate')) + " :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder')
    },
    model: {
      value: (_vm.fromDateAllocated),
      callback: function($$v) {
        _vm.fromDateAllocated = $$v
      },
      expression: "fromDateAllocated"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('common.createdToDate')) + " :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder')
    },
    model: {
      value: (_vm.toDateAllocated),
      callback: function($$v) {
        _vm.toDateAllocated = $$v
      },
      expression: "toDateAllocated"
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticStyle: {
      "margin-top": "30px",
      "margin-left": "80%"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.getAllocatedPendingBatchesSearch
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" " + _vm._s(_vm.$t('common.searchBtn')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetAllAllocatedForm
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" " + _vm._s(_vm.$t('common.resetBtn')))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "height": "25px"
    }
  }, [_c('div', {
    staticClass: "col-md-4 cardlistheader"
  }, [_c('h4', {
    staticClass: "header",
    staticStyle: {
      "color": "black"
    }
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('consolidation.batchAssigned')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 cardlistheader"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('b', {
    staticStyle: {
      "font-family": "cursive,fantasy",
      "color": "green"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.$t('common.table.count')) + " - " + _vm._s(this.listAllocatedInpickingData.totalquantity))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [(_vm.listAllocatedInpickingData.totalquantity > 0 && _vm.allocatedbatchids != '') ? _c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "margin-top": "-10px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.pickerReAssignmentShow = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('consolidation.btnReAssignToPicker')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-0.5 cardlistheader"
  }, [_c('loader', {
    staticStyle: {
      "margin-right": "-400px"
    },
    attrs: {
      "isLoading": _vm.isLoadingforxls
    }
  })], 1), _vm._v(" "), (_vm.download && _vm.listAllocatedInpickingData.totalquantity) ? _c('div', {
    staticClass: "col-md-0.5"
  }, [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    staticStyle: {
      "margin-right": "-150px"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.Choosetype3(1)
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.downloadBtn')))])]) : _vm._e(), _vm._v(" "), (_vm.show && _vm.listAllocatedInpickingData.totalquantity) ? _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    staticStyle: {
      "margin-right": "-30px"
    },
    attrs: {
      "disabled": _vm.isLoading,
      "title": _vm.$t('common.downloadCsv')
    },
    on: {
      "click": function($event) {
        _vm.getAllocatedPendingBatchesCSV(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])]) : _vm._e(), _vm._v(" "), (_vm.limitExeed && _vm.show && _vm.listAllocatedInpickingData.totalquantity) ? _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    staticStyle: {
      "margin-right": "5px"
    },
    attrs: {
      "disabled": _vm.isLoading,
      "title": _vm.$t('common.downloadXls')
    },
    on: {
      "click": function($event) {
        _vm.getAllocatedPendingBatchesForXls(3)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o"
  })])]) : _vm._e(), _vm._v(" "), (!_vm.limitExeed && _vm.show && _vm.listAllocatedInpickingData.totalquantity) ? _c('div', {
    staticClass: "col-md-1"
  }, [_c('download-excel', {
    staticClass: "btn btn-info downloadbutton",
    staticStyle: {
      "margin-right": "5px"
    },
    attrs: {
      "before-generate": _vm.startDownload,
      "before-finish": _vm.finishDownload,
      "title": _vm.$t('common.downloadXls'),
      "data": _vm.listReportDataforxls3,
      "header": _vm.dataFilter2,
      "fields": _vm.csvFieldsForXls3,
      "worksheet": "MyWorksheet",
      "name": _vm.reportname3
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable",
    attrs: {
      "id": "my-table"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "bind-title": "Select All"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectAllAllocated),
      expression: "selectAllAllocated"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.selectAllAllocated) ? _vm._i(_vm.selectAllAllocated, null) > -1 : (_vm.selectAllAllocated)
    },
    on: {
      "click": _vm.selectAllCheckboxAllocated,
      "__c": function($event) {
        var $$a = _vm.selectAllAllocated,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.selectAllAllocated = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.selectAllAllocated = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.selectAllAllocated = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.zoneName')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.batchID')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('consolidation.batchStatus')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('consolidation.picksTasks')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('consolidation.batchCreatedDatetime')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('consolidation.batchAssignedDatetime')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.assignedTo')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('consolidation.completedPickTask')))])])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.listAllocatedInpickingData.result), function(data) {
    return _c('tr', {
      staticClass: "text-center cardreporttabletr"
    }, [_c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.allocatedbatchids),
        expression: "allocatedbatchids"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": data.batchid,
        "checked": Array.isArray(_vm.allocatedbatchids) ? _vm._i(_vm.allocatedbatchids, data.batchid) > -1 : (_vm.allocatedbatchids)
      },
      on: {
        "change": function($event) {
          _vm.resetAllAllocated(data)
        },
        "__c": function($event) {
          var $$a = _vm.allocatedbatchids,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = data.batchid,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.allocatedbatchids = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.allocatedbatchids = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.allocatedbatchids = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getZoneName(data.zoneid)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.batchid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.status))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.batchcount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("momentDateTime")(data.createddate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("momentDateTime")(data.assigneddate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.email))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.pickedcount))])])
  }), _vm._v(" "), (_vm.listAllocatedInpickingData.totalquantity <= 0 || (_vm.listAllocatedInpickingData.result && _vm.listAllocatedInpickingData.result.length <= 0)) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "12",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.table.noRecordFoundMsg')))])]) : _vm._e()], 2)])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.totalPage > 0) ? _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPage,
      "total": _vm.totalRows,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPage
    },
    on: {
      "pagechanged": _vm.onPageChange1
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('b-tab', {
    staticClass: "show",
    attrs: {
      "title": _vm.$t('consolidation.completedBatchesTab')
    },
    on: {
      "click": _vm.resetAllCompletedForm
    }
  }, [_c('div', {
    staticClass: "card-headerfrmOrd"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.zoneName')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.zoneBatchPending),
      expression: "zoneBatchPending"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "zoneBatchPending"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.zoneBatchPending = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getCompletedBatchesSearch]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('common.zonePlaceHolder')))]), _vm._v(" "), _vm._l((_vm.zonelistData), function(zone) {
    return _c('option', {
      domProps: {
        "value": zone.zoneid
      }
    }, [_vm._v(_vm._s(zone.zonename))])
  })], 2)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('consolidation.picker')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pickeridCompleted),
      expression: "pickeridCompleted"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "pickeridCompleted"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.pickeridCompleted = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getCompletedBatchesSearch]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('common.selectPicker')))]), _vm._v(" "), _vm._l((_vm.pickerListData), function(user_obj) {
    return _c('option', {
      domProps: {
        "value": user_obj.userid
      }
    }, [_vm._v(_vm._s(user_obj.email))])
  })], 2)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('common.createdFromDate')) + " :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder')
    },
    model: {
      value: (_vm.fromDateCompleted),
      callback: function($$v) {
        _vm.fromDateCompleted = $$v
      },
      expression: "fromDateCompleted"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('common.createdToDate')) + " :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder')
    },
    model: {
      value: (_vm.toDateCompleted),
      callback: function($$v) {
        _vm.toDateCompleted = $$v
      },
      expression: "toDateCompleted"
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticStyle: {
      "margin-top": "30px",
      "margin-left": "80%"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.getCompletedBatchesSearch
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" " + _vm._s(_vm.$t('common.searchBtn')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetAllCompletedForm
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" " + _vm._s(_vm.$t('common.resetBtn')))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "height": "25px"
    }
  }, [_c('div', {
    staticClass: "col-md-4 cardlistheader"
  }, [_c('h4', {
    staticClass: "header",
    staticStyle: {
      "color": "black"
    }
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('consolidation.batchCompleted')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 cardlistheader"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('b', {
    staticStyle: {
      "font-family": "cursive,fantasy",
      "color": "green"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.$t('common.table.count')) + " - " + _vm._s(this.listCompletedData.totalquantity))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [(_vm.listCompletedData.totalquantity > 0 && _vm.allocatedbatchids != '') ? _c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "margin-top": "-10px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.pickerReAssignmentShow = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('consolidation.btnReAssignToPicker')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-0.5 cardlistheader"
  }, [_c('loader', {
    staticStyle: {
      "margin-right": "-400px"
    },
    attrs: {
      "isLoading": _vm.isLoadingforxls
    }
  })], 1), _vm._v(" "), (_vm.download && _vm.listCompletedData.totalquantity) ? _c('div', {
    staticClass: "col-md-0.5"
  }, [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    staticStyle: {
      "margin-right": "-150px"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.Choosetype4(1)
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.downloadBtn')))])]) : _vm._e(), _vm._v(" "), (_vm.show && _vm.listCompletedData.totalquantity) ? _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    staticStyle: {
      "margin-right": "-30px"
    },
    attrs: {
      "disabled": _vm.isLoading,
      "title": _vm.$t('common.downloadCsv')
    },
    on: {
      "click": function($event) {
        _vm.getCompletedBatchesCSV(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])]) : _vm._e(), _vm._v(" "), (_vm.limitExeed && _vm.show && _vm.listCompletedData.totalquantity) ? _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    staticStyle: {
      "margin-right": "5px"
    },
    attrs: {
      "disabled": _vm.isLoading,
      "title": _vm.$t('common.downloadXls')
    },
    on: {
      "click": function($event) {
        _vm.getCompletedBatchesForXls(3)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o"
  })])]) : _vm._e(), _vm._v(" "), (!_vm.limitExeed && _vm.show && _vm.listCompletedData.totalquantity) ? _c('div', {
    staticClass: "col-md-1"
  }, [_c('download-excel', {
    staticClass: "btn btn-info downloadbutton",
    staticStyle: {
      "margin-right": "5px"
    },
    attrs: {
      "before-generate": _vm.startDownload,
      "before-finish": _vm.finishDownload,
      "title": _vm.$t('common.downloadXls'),
      "data": _vm.listReportDataforxls,
      "header": _vm.dataFilter2,
      "fields": _vm.csvFieldsForXls,
      "worksheet": "MyWorksheet",
      "name": _vm.reportname4
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable",
    attrs: {
      "id": "my-table"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.zoneName')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.batchID')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('consolidation.batchStatus')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('consolidation.picksTasks')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('consolidation.batchCreatedDatetime')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('consolidation.batchAssignedDatetime')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.assignedTo')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('consolidation.completedPickTask')))])])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.listCompletedData.result), function(data) {
    return _c('tr', {
      staticClass: "text-center cardreporttabletr"
    }, [_c('td', [_vm._v(_vm._s(_vm.getZoneName(data.zoneid)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.batchid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.status))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.batchcount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("momentDateTime")(data.createddate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("momentDateTime")(data.assigneddate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.email))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.pickedcount))])])
  }), _vm._v(" "), (_vm.listCompletedData.totalquantity <= 0 || (_vm.listCompletedData.result && _vm.listCompletedData.result.length <= 0)) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "12",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.table.noRecordFoundMsg')))])]) : _vm._e()], 2)])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.totalPage > 0) ? _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPage,
      "total": _vm.totalRows,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPage
    },
    on: {
      "pagechanged": _vm.onPageChange2
    }
  }) : _vm._e()], 1)])], 1)], 1)]), _vm._v(" "), _c('b-modal', {
    staticClass: "confirmation",
    attrs: {
      "size": "lm",
      "title": "Picker Assign"
    },
    model: {
      value: (_vm.pickerAssignmentShow),
      callback: function($$v) {
        _vm.pickerAssignmentShow = $$v
      },
      expression: "pickerAssignmentShow"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('common.pickerAssignment')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.pickerAssignmentShow = false;
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.orderPickers')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pickerid),
      expression: "pickerid"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "name": "pickerid"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.pickerid = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('common.selectPicker')))]), _vm._v(" "), _vm._l((_vm.pickerListData), function(user_obj) {
    return _c('option', {
      domProps: {
        "value": user_obj.userid
      }
    }, [_vm._v(_vm._s(user_obj.email))])
  })], 2)]), _vm._v(" "), (_vm.pickerid == '') ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.SelectPickerErr))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "320px",
      "margin-bottom": "10px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.assignBatchToPicker()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-random"
  }), _vm._v(_vm._s(_vm.$t('common.assignBtn')) + "\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.pickerAssignmentShow = false;
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(_vm._s(_vm.$t('common.cancelBtn')) + "\n            ")])])])])]), _vm._v(" "), _c('b-modal', {
    staticClass: "confirmation",
    attrs: {
      "size": "lm",
      "title": "Picker Assign"
    },
    model: {
      value: (_vm.pickerReAssignmentShow),
      callback: function($$v) {
        _vm.pickerReAssignmentShow = $$v
      },
      expression: "pickerReAssignmentShow"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('consolidation.pickerReAssignment')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.pickerReAssignmentShow = false;
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.orderPickers')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reAssignpickerid),
      expression: "reAssignpickerid"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "name": "reAssignpickerid"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.reAssignpickerid = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('common.selectPicker')))]), _vm._v(" "), _vm._l((_vm.pickerListData), function(user_obj) {
    return _c('option', {
      domProps: {
        "value": user_obj.userid
      }
    }, [_vm._v(_vm._s(user_obj.email))])
  })], 2)]), _vm._v(" "), (_vm.pickerid == '') ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.SelectPickerErr))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "320px",
      "margin-bottom": "10px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.reAssignBatchToPicker()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-random"
  }), _vm._v(_vm._s(_vm.$t('common.assignBtn')) + "\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.pickerReAssignmentShow = false;
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(_vm._s(_vm.$t('common.cancelBtn')) + "\n            ")])])])])])], 1)], 1)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-760e8280", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-760e8280","hasScoped":true}!./src/views/components/zonepickingreport/zonepickingreport.component.html
// module id = 1833
// module chunks = 0